export const FETCH_AUDIENCE_SIZE = 'FETCH_AUDIENCE_SIZE';
export const FETCH_AUDIENCE_SIZE_SUCCESS = 'FETCH_AUDIENCE_SIZE_SUCCESS';
export const FETCH_AUDIENCE_SIZE_FAILED = 'FETCH_AUDIENCE_SIZE_FAILED';
export const CLEAR_AUDIENCE_SIZE_ESTIMATE = 'CLEAR_AUDIENCE_SIZE_ESTIMATE';

export function fetchAudienceSize() {
  return {
    type: FETCH_AUDIENCE_SIZE,
  };
}

export function fetchAudienceSizeSuccess(payload) {
  return {
    type: FETCH_AUDIENCE_SIZE_SUCCESS,
    payload,
  };
}

export function fetchAudienceSizeFailed(e) {
  return {
    type: FETCH_AUDIENCE_SIZE_FAILED,
    err: e,
  };
}

export function clearEstimate() {
  return {
    type: CLEAR_AUDIENCE_SIZE_ESTIMATE,
  };
}



// WEBPACK FOOTER //
// ./src/actions/audienceSizer.js